// import { createContext, useState } from 'react';

// export const UserContext = createContext(); // Correctamente exportado

// export const UserProvider = ({ children }) => {
//   const [User, setUser] = useState([]);

//   const toggleUser = (rol, name) => {
//     console.log(rol, name);
//     setUser([rol,name]);
//   };

//   return (
//     <UserContext.Provider value={{ User, toggleUser }}>
//       {children}
//     </UserContext.Provider>
//   );
// };

import { createContext, useState } from 'react';

export const UserContext = createContext();

const decode = (data) => {
  try {
    return JSON.parse(atob(data));
  } catch {
    return [];
  }
};

export const UserProvider = ({ children }) => {
  const [User, setUser] = useState(() => {
    const stored = localStorage.getItem('User');
    return stored ? decode(stored) : [];
  });

  const toggleUser = (rol, name) => {
    const userData = [rol, name];
    setUser(userData);
    localStorage.setItem('User', btoa(JSON.stringify(userData)));
  };

  return (
    <UserContext.Provider value={{ User, toggleUser }}>
      {children}
    </UserContext.Provider>
  );
};
